import { render, staticRenderFns } from "./BranchLearningProgress.vue?vue&type=template&id=2745874f&scoped=true&lang=pug&"
import script from "./BranchLearningProgress.vue?vue&type=script&lang=ts&"
export * from "./BranchLearningProgress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2745874f",
  null
  
)

export default component.exports